<template>
  <div class="container service">
    <com-title title="推荐服务"></com-title>
    <h4>大咖面对面：与大会讲师深度交流</h4>
    <div class="word">极客邦科技每年举办10+场全球性技术大会，拥有丰富的国内外讲师资源，助力企业IT技术团队人才职业发展和技能提升。如果您在大会上听讲师分享时间太短不过瘾，想要和大会讲师进行深度讨论，想要邀请大会讲师到企业内部做分享，可以随时联系我们的企业培训顾问，我们会根据您的企业需求，预约讲师并制定技术培训计划。
    </div>
  </div>
</template>
<script>
import comTitle from '@/base/title'
export default {
  data () {
    return {}
  },
  components: {
    comTitle
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/variable.sass'

+mobile
  .container
    width: 88vw

div.service
  text-align: center
  padding-bottom: 65px
  border-bottom: 1px solid #e8e8e8
  h4
    font-size: 20px
    color: #353535
    margin-bottom: 20px
  .word
   text-align: left
   +mobile
     font-size: 14px
</style>
